import { Link } from 'react-router-dom'
import type { Footer as FooterType, Okved } from '../types/content'

interface FooterProps {
  data: FooterType
  okved: Okved
  /** Открыть баннер согласия заново — отозвать согласие
   *  должно быть не сложнее, чем его дать */
  onOpenCookieSettings?: () => void
}

export default function Footer({ data, okved, onOpenCookieSettings }: FooterProps) {
  return (
    <footer id="contacts" className="bg-dark-secondary border-t border-border py-12">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/logo.png"
                alt="Плейнавтика"
                className="h-8 w-auto opacity-90"
              />
              <span
                className="text-xl font-bold text-gradient tracking-wide"
                style={{ fontFamily: "'Exo 2', sans-serif" }}
              >
                Плейнавтика
              </span>
            </div>
            <p className="text-sm text-gray-400">
              {data.company.name}<br />
              ОГРН: {data.company.ogrn}<br />
              ИНН: {data.company.inn}
            </p>
          </div>

          {/* Contacts */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Контакты</h4>
            <div className="space-y-2">
              <a
                href={`tel:${data.contacts.phone.replace(/\s/g, '')}`}
                className="block text-sm text-gray-400 hover:text-primary transition-colors"
              >
                {data.contacts.phone}
              </a>
              <a
                href={`mailto:${data.contacts.email}`}
                className="block text-sm text-gray-400 hover:text-primary transition-colors"
              >
                {data.contacts.email}
              </a>
              <span className="block text-sm text-gray-400">
                {data.company.address}
              </span>
            </div>
          </div>

          {/* Activity */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Деятельность</h4>
            <div className="space-y-2">
              <span className="block text-sm text-gray-400">
                {data.company.activity.primary}
              </span>
              {data.company.activity.secondary.map(activity => (
                <span key={activity} className="block text-sm text-gray-400">
                  {activity}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* OKVED & Mintsifry Section */}
        <div className="border-t border-border pt-8 mb-8">
          <div className="grid md:grid-cols-2 gap-8 text-xs text-gray-500">
            {/* OKVED */}
            <div>
              <p className="mb-2">
                <span className="text-gray-400">Основной ОКВЭД:</span>{' '}
                {okved.okved.primary.code} — {okved.okved.primary.name}
              </p>
              <p className="mb-2">
                <span className="text-gray-400">Дополнительные ОКВЭД:</span>{' '}
                {okved.okved.secondary.map(o => o.code).join(', ')}
              </p>
              <p>
                {okved.registration.certificate} от {okved.registration.date}
              </p>
            </div>

            {/* Mintsifry */}
            <div>
              <p className="text-gray-400 mb-2">Коды видов деятельности ({okved.mintsifry.order}):</p>
              {okved.mintsifry.codes.map(code => (
                <p key={code.code} className="mb-1">
                  <span className="text-gray-400">{code.code}</span> — {code.name}
                </p>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-border gap-4">
          <div className="text-sm text-gray-500">
            {data.copyright}
            <span className="ml-2 text-gray-700 text-xs" title="Версия сайта">
              v.{__COMMIT_HASH__}
            </span>
          </div>
          <div className="flex items-center gap-4 text-xs text-gray-500">
            <a href="#documents" className="hover:text-primary transition-colors">
              Документы
            </a>
            <span className="text-primary/30">|</span>
            <Link to="/privacy" className="hover:text-primary transition-colors">
              Политика обработки ПДн
            </Link>
            <span className="text-primary/30">|</span>
            <Link to="/personal-data" className="hover:text-primary transition-colors">
              Согласие на обработку
            </Link>
            {onOpenCookieSettings && (
              <>
                <span className="text-primary/30">|</span>
                <button
                  type="button"
                  onClick={onOpenCookieSettings}
                  className="hover:text-primary transition-colors"
                >
                  Настройки cookie
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </footer>
  )
}
